const API_URL = process.env.REACT_APP_APIHOST || "http://localhost:3033";

let sessionId = null;

function getSessionId() {
    if (sessionId) return sessionId;
    sessionId = sessionStorage.getItem("forte_sid");
    if (!sessionId) {
        sessionId = Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
        sessionStorage.setItem("forte_sid", sessionId);
    }
    return sessionId;
}

export function track(action, detail, page) {
    try {
        // Try to get user email from JWT token
        let userEmail = null;
        try {
            const token = localStorage.getItem("token");
            if (token) { const p = JSON.parse(atob(token.split(".")[1])); userEmail = p.email || null; }
        } catch (e) {}
        const payload = {
            sessionId: getSessionId(),
            page: page || window.location.pathname,
            action,
            detail: detail || null,
            referrer: document.referrer || null,
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            userEmail,
        };
        navigator.sendBeacon(API_URL + "/track", new Blob([JSON.stringify(payload)], { type: "application/json" }));
    } catch (e) {}
}

export function trackPageView(page) {
    track("pageview", null, page);
}

export function trackAction(action, detail) {
    track(action, detail);
}
